export default __webpack_public_path__ + "static/media/batteryoff.0f3d8441.svg";